import React from "react";
import style from "./index.module.scss";
import { Icon, Tooltip } from "antd";
import className from "classnames";
import { configType, saveDcGradeDecimalSet } from "service/score";

import icon from "./img/icon.png";
import icon1 from "./img/icon1.png";
import { errorMessage } from "service/service";
import { ResultMessage } from "components/ResultMessage";
import useRequestFn from "utils/useRequestFn";
import { queryDcGradeDecimalSetItem } from "../../../../../../../../service/score";

interface TableTitleProps {
    title: string;
    dataIndex: string;
    weight: string | null;
    isCustom?: boolean; //是否是自定义项
    styles?: React.CSSProperties;
    updateData: () => void;
    config: queryDcGradeDecimalSetItem | null; //成绩取整或保留小数的配置数据
    refreshConfig: () => void;
}

const Index = ({
    title,
    dataIndex,
    weight,
    isCustom = false,
    styles,
    updateData,
    config: data,
    refreshConfig
}: TableTitleProps) => {
    const [onSave] = useRequestFn(saveDcGradeDecimalSet);

    const onChangeGrade = async () => {
        const params = {
            ...data,
            config:
                data?.config === configType.Decimal
                    ? configType.Integer
                    : configType.Decimal
        };

        try {
            await onSave(params);
            await updateData();
            await refreshConfig();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    const tooltipTitle = (
        <div className={style.toolTip}>
            <div className={style.tTitle}>总成绩</div>
            <div className={style.tContent}>
                系统根据考核方案中设置的权重，计算得到的成绩。 <br />
                总成绩=折算后平时总成绩+折算后期末总成绩
                <br />
                如果设置了额外加分，则总成绩=折算后平时总成绩+折算后期末总成绩+额外加分成绩{" "}
            </div>
            <div className={style.tTitle}>最终成绩</div>
            <div className={style.tContent}>
                在总成绩的基础上，有成绩修改、调整后得到的本课程最终成绩。
            </div>
        </div>
    );
    return (
        <div className={style.root}>
            <div className={style.flex}>
                <div className={style.b}>
                    <div className={style.title}>
                        {title}
                        {dataIndex === "finalGrade" && (
                            <Tooltip placement="top" title={tooltipTitle}>
                                <Icon type="question-circle" />
                            </Tooltip>
                        )}
                    </div>

                    {weight && dataIndex !== "finalGrade" && (
                        <div
                            className={className(style.weight, {
                                [style.yellowColor]: [
                                    "dailyTotalGrade",
                                    "finalTotalGrade",
                                    "totalGrade"
                                ].includes(dataIndex)
                            })}
                            style={styles}>
                            {isCustom && (
                                <img src={require("./img/img.png")} alt="" />
                            )}
                            {weight}
                        </div>
                    )}
                </div>

                {["totalGrade"].includes(dataIndex) && data && (
                    <div className={style.btn} onClick={onChangeGrade}>
                        <img
                            src={
                                data?.config === configType.Decimal
                                    ? icon
                                    : icon1
                            }
                            alt=""
                        />
                        <div className={style.tip}>
                            {data?.config === configType.Decimal
                                ? "保留整数"
                                : "保留小数"}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Index;
